// extracted by mini-css-extract-plugin
module.exports = {"Panel":"ControlsResultsWrapper_Panel__2RnNK"};